/**
 * Public launch / list prices for 2025–26 multi-resort passes (adult).
 * Used only for cost-per-day ROI estimates. Not affiliated with any pass brand.
 *
 * Sources (cited for transparency; prices change — treat as estimates):
 * - Epic Pass adult full: $1,051
 *   Vail Resorts newsroom, Mar 4 2025:
 *   https://news.vailresorts.com/2025-03-04-2025-26-Epic-Pass-Launches-at-Lowest-Price-of-the-Year-Switzerlands-Verbier-4-Vallees-is-Now-Even-More-Epic-with-Expanded-Access-for-Pass-Holders
 * - Ikon Pass adult full (online): $1,329
 *   PeakRankings / Alterra 2025-26 debut coverage:
 *   https://www.peakrankings.com/content/ikon-pass-debuts-for-2025-26-with-a-basin-unlimited-on-full-pass-base-plus-pass-discontinued
 * - Indy Base Pass: use mid-season public sale figure $369 (public after waitlist);
 *   PeakRankings Indy 2025-26:
 *   https://www.peakrankings.com/content/2025-26-indy-pass-debuts-with-wild-250-resort-guarantee
 *   (Final late-sale Base was higher; MVP uses early public list price for ROI.)
 */

export type PassId = 'epic' | 'ikon' | 'indy' | 'none'

export interface PassOption {
  id: PassId
  label: string
  short: string
  priceUsd: number
  blurb: string
}

export const PASSES: PassOption[] = [
  {
    id: 'epic',
    label: 'Epic Pass',
    short: 'Epic',
    priceUsd: 1051,
    blurb: 'Vail Resorts multi-mountain · 2025–26 adult launch',
  },
  {
    id: 'ikon',
    label: 'Ikon Pass',
    short: 'Ikon',
    priceUsd: 1329,
    blurb: 'Alterra multi-mountain · 2025–26 adult online',
  },
  {
    id: 'indy',
    label: 'Indy Pass',
    short: 'Indy',
    priceUsd: 369,
    blurb: 'Indy Base · 2025–26 early public sale estimate',
  },
  {
    id: 'none',
    label: 'No multi-pass',
    short: 'Day tickets',
    priceUsd: 0,
    blurb: 'Track days without a multi-resort pass',
  },
]

export function passById(id: PassId): PassOption {
  return PASSES.find((p) => p.id === id) ?? PASSES[3]
}
